import React, { useEffect } from "react";
import StoriesReachCharts from "./StoriesReachCharts";
import NoData from "../NoData/NoData";
import Loading from "../Loading/Loading";
function StoriesReach(props) {
    const chartLoading = props.chartDataLoading?.insta_story_by_reach;
    const isNoData = props.pageStatus || props.chartData?.insta_story_by_reach?.nodata;

    useEffect(() => {
        props.setIsNoDataState(isNoData);
    }, [props.chartData, props.pageStatus]);

    return (
        <>
            {chartLoading && <Loading />}
            {!isNoData && !chartLoading && (
                <StoriesReachCharts
                    chartData={props.chartData.insta_story_by_reach}
                    showLegend={props.showLegend}
                    showGridLines={props.showGridLines}
                    showLabel={props.showLabel}
                    graphType={props.graphType}
                    isIGPage={props.isIGPage}
                    widgetContainerRef={props.widgetContainerRef}
                    showAverage={props.showAverage}
                />
            )}
            {isNoData && !chartLoading && <NoData message={props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />}
        </>
    );
}

export default StoriesReach;
